export default __webpack_public_path__ + "static/media/Blue Christmas.928ff298.mp3";